import React from "react";

export default class SceneErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  componentDidCatch() { /* swallow: la scena 3D non deve far crashare l'editor */ }
  render() {
    if (this.state.err) {
      return (
        <div className="h-full flex items-center justify-center text-white/70 text-sm p-4 text-center" data-testid="scene-error">
          Impossibile visualizzare la scena 3D. Prova a cambiare indirizzo o ricaricare la pagina.
        </div>
      );
    }
    return this.props.children;
  }
}
